import { Button } from '@a-ui/react';
import React, { useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { getAvailableActions } from '../../helpers/task.helper';
import Spinner from '../Spinner/Spinner';

const Actions = (props) => {
  const dispatch = useDispatch();
  const { task } = useSelector(state => state.tasks)
  const { user } = useSelector(state => state.user);
  const { domains } = useSelector(state => state.domains);

  const [loading, setLoading]  = useState(false);

  const domainForTask = domains.find((domain) => String(domain.id) === String(task?.domainId));
  const multipleTimeRegistrationsPerTaskActive = domainForTask?.multipleTimeRegistrationsPerTaskActive === true;

  const actions = getAvailableActions(task, user, loading, setLoading, dispatch, multipleTimeRegistrationsPerTaskActive);

  const { complete, stop, start, pause, release, claim } = actions;
  return <>
    { start.visible && <Button
      className={`${start.isLoading && "has-icon-left"} a-button u-margin-right-xs u-margin-bottom-xs`}
      onClick={start.action}
      disabled={start.disabled}
      addOn={{
        type: "icon",
        align: "left",
        iconProps: {
          name: "ai-controls-play",
        },
      }}
    >{ start.isLoading && <Spinner>Aan het laden …</Spinner> }Taak starten</Button> }


    { pause.visible && <Button
      className={`${pause.isLoading && "has-icon-left"} a-button u-margin-right-xs u-margin-bottom-xs`}
      onClick={pause.action}
      disabled={pause.disabled}
      addOn={{
        type: "icon",
        align: "left",
        iconProps: {
          name: "ai-controls-pause",
        },
      }}
    >{ pause.isLoading && <Spinner>Aan het laden …</Spinner> }Taak pauzeren</Button> }

    { complete.visible && <Button
      className={`${complete.isLoading && "has-icon-left"} a-button a-button--success u-margin-bottom-xs u-margin-right-xs`}
      onClick={complete.action}
      disabled={complete.disabled}
      addOn={{
        type: "icon",
        align: "left",
        iconProps: {
          name: "ai-check-1",
        },
      }}
    > { complete.isLoading && <Spinner>Aan het laden …</Spinner> }Taak voltooien</Button> }

    { stop.visible && <Button
      className={`${stop.isLoading && "has-icon-left"} a-button a-button--danger u-margin-bottom-xs u-margin-right-xs`}
      onClick={stop.action}
      disabled={stop.disabled}
      addOn={{
        type: "icon",
        align: "left",
        iconProps: {
          name: "ai-controls-stop",
        },
      }}
    > { stop.isLoading && <Spinner>Aan het laden …</Spinner> }Taak afbreken</Button> }

    { release.visible && <Button
      className={`${release.isLoading && "has-icon-left"} a-button a-button--outlined u-margin-right-xs u-margin-bottom-xs`}
      onClick={release.action}
      disabled={release.disabled}
    >{ release.isLoading && <Spinner>Aan het laden …</Spinner> }Taak vrijgeven</Button> }

    { claim.visible && <Button
      className={`${claim.isLoading && "has-icon-left"} a-button a-button--outlined u-margin-right-xs u-margin-bottom-xs`}
      onClick={claim.action}
      disabled={release.visible}
    >{ claim.isLoading && <Spinner>Aan het laden …</Spinner> }Taak claimen</Button> }
  </>
}
export default Actions;
